import { useAuth0 } from '@auth0/auth0-react';
import { Button } from '@sunstone/ui';
import { ShieldX } from 'lucide-react';
import { Link } from 'react-router';
import { UniphoreLogo } from '@/components/ui/UniphoreLogo';

interface AccessBlockedPageProps {
  title: string;
  message: string;
  detail?: string;
  action: { type: 'link'; label: string; to: string } | { type: 'logout' } | { type: 'login' };
}

export function AccessBlockedPage({ title, message, detail, action }: AccessBlockedPageProps) {
  const { logout, loginWithRedirect } = useAuth0();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="max-w-sm text-center">
        <UniphoreLogo className="h-10 mb-8" />
        <ShieldX className="mx-auto mb-4 h-12 w-12 text-destructive" />
        <h1 className="mb-2 text-2xl font-semibold">{title}</h1>
        <p className="mb-1 text-muted-foreground">{message}</p>
        {detail && <p className="mb-4 text-sm text-muted-foreground">{detail}</p>}
        {action.type === 'link' ? (
          <Link to={action.to} className="text-sm text-primary underline underline-offset-4">
            {action.label}
          </Link>
        ) : action.type === 'logout' ? (
          <Button
            variant="destructive"
            onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
          >
            Log out
          </Button>
        ) : (
          <Button onClick={() => loginWithRedirect()}>Log in</Button>
        )}
      </div>
    </div>
  );
}
